export default "__VITE_ASSET__00bf35e9__"